import React from 'react';
import ProductText from '../components/Product_text'

const ProductLightweight = () => {
    return (
        <div>
            <ProductText />ghkjiuilkk
        </div>
    );
}

export default ProductLightweight;
